import { Component, OnInit, inject } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { PageChangeEvent as PagerChangeEvent } from '@progress/kendo-angular-pager'
import { skip } from 'rxjs/operators'

import { SearchDataService } from '../../../services/search-data.service'
import {
  SearchStateInputs,
  SearchStateService,
} from '../../../services/search-state.service'
import { SearchUrlService } from '../../../services/search-url.service'

@Component({
  standalone: false,
  styleUrls: ['./search.component.scss'],
  templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute)
  searchStateService = inject(SearchStateService)
  searchDataService = inject(SearchDataService)
  private searchUrlService = inject(SearchUrlService)

  public pageSize = 10
  public skip = 0

  public ngOnInit(): void {
    // TODO: Figure out how to streamline this, to not need to skip the initial default state in cases where URL is providing initial state
    this.searchStateService.state
      .pipe(skip(1))
      .subscribe((state: SearchStateInputs) => {
        this.searchUrlService.gotoUrl(state)
      })

    this.activatedRoute.queryParams.subscribe((params) => {
      this.populateFromUrl(params)
    })
  }

  private populateFromUrl(queryParams: Params): void {
    let searchState: SearchStateInputs =
      this.searchUrlService.searchStateFromString(queryParams)
    this.skip = searchState.page * this.pageSize
    if (!searchState) {
      searchState = this.searchStateService.state.value
    }
    this.searchStateService.setState(searchState)
  }

  public onPageChange(e: PagerChangeEvent): void {
    this.skip = e.skip
    this.searchStateService.setPage(this.skip / this.pageSize)
  }
}
